<template>
  <div class="store-opening-time-new">
    <fn-store-current-opening-time
      :store="store"
      :show-opening-time="!openingTimesShown"
      :week-day="$t(`weekDays[${currentDayIndex}]`)"
      show-today-opening-time-with-week-day
    />
  </div>
</template>

<script setup lang="ts">
defineProps({
  store: {
    type: Object,
    required: true,
  },
  storeCard: {
    type: Boolean,
  },
});

const openingTimesShown = ref(false);
const currentDayIndex = computed(() => {
  const currentDate = new Date();

  // set current day to yesterday to fix divergence Array from BE and week-structure in JS
  currentDate.setDate(currentDate.getDate() - 1);

  return currentDate.getDay();
});
</script>

<style lang="scss" scoped>
.store-opening-time-new {
  margin-bottom: $pad;
  display: flex;
  gap: math.div($pad, 2);
  align-items: baseline;

  :deep(.store-current-opening-time) {
    margin-bottom: 0;
  }
}
</style>
